<template>
  <div class="register_pay">
    <div class="innerUpload_flex">
      <!-- <img :src="pay_img" style="max-width: 100%;" alt=""> -->
      <div>
        <div class="innerUpload">
          <span>账号：</span>
          <span>0200007609089112580</span>
        </div>
        <div class="innerUpload">
          <span>开户名：</span>
          <span>中国建筑业协会</span>
        </div>
        <div class="innerUpload">
          <span>开户行：</span>
          <span>工商银行北京紫竹院支行</span>
        </div>
        <div class="innerUpload" style="color: #c22c25">
          <span>会费标准：</span>
          <span>300元/年</span>
        </div>
        <div class="innerUpload">
          <span>缴费时间</span>
          <el-date-picker
            v-model="time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="innerUpload">
          <span>缴费凭证</span>
          <el-upload
            class="avatar-uploader"
            :headers="uploadHeaders"
            :action="upLoadUrl"
            :data="uploadData"
            accept=".png,.jpg,.ipeg"
            :on-success="handleSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
          </el-upload>
        </div>
        <div class="innerUpload">
          <span>备注：个人会员会费+姓名</span>
          <!-- <span>备注：</span>
					<span></span> -->
        </div>
      </div>
    </div>
    <span
      style="margin: 20px; display: block; text-align: center"
      class="dialog-footer"
    >
      <el-button @click="$emit('prveStep')">上一步</el-button>
      <el-button class="primary_btn" @click="testUpload">下一步</el-button>
    </span>
  </div>
</template>

<script>
import {
  registerPay,
  // uploadPayRecom
} from "../../../api/moudles/user.js";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";

export default {
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      pay_img: require("@/assets/img/webIndex/pay.png"),
      dialogVisible: false,
      time: "",
      imageUrl: "",
    };
  },
  props: ["memberCode"],
  created() {
    const stepPay = JSON.parse(localStorage.getItem("stepPay"));
    if (stepPay) {
      this.time = stepPay.payTime;
      this.imageUrl = stepPay.proveImg;
    }
  },
  methods: {
    testUpload() {
      if (!this.time) {
        this.$message.error("请选择缴费时间");
        return;
      }
      if (!this.imageUrl) {
        this.$message.error("请上传缴费凭证");
        return;
      }
      this.registerPay();
    },
    async registerPay() {
      await registerPay({
        data: {
          payTime: this.time,
          proveImg: this.imageUrl,
          memberCode: this.memberCode,
        },
        success: (res) => {
          if (
            (res.code == 200 || res.code == 0) &&
            res.msg === "缴费填写成功"
          ) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            setTimeout(() => {
              // 给父组件发送信息，xiayibu
              this.$emit("addActive");
            }, 1500);
          } else {
            this.$message.error(res.msg || "缴费凭证提交失败");
          }
        },
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return isLt2M;
    },
    handleSuccess(file) {
      if (!file || (file.code !== 0 && file.code !== 200) || !file.data) {
        this.imageUrl = "";
        this.$message.error((file && file.msg) || "上传失败");
        return;
      }
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
    },
    handleUploadError() {
      this.imageUrl = "";
      this.$message.error("上传失败");
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .register_pay {
    padding: 20px 20px;
  }

  .innerUpload_flex {
    display: flex;
    flex-flow: column;
  }
}

@media screen and (min-width: 750px) {
  .register_pay {
    width: 520px;
    margin: 20px auto;
  }

  .innerUpload_flex {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .innerUpload_flex img {
    height: 300px;
  }
}

>>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}

>>> .el-dialog__footer {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.primary_btn {
  background-color: #c22c25;
  color: #fff;
}

.innerUpload {
  display: flex;
  margin-bottom: 20px;
}

.innerUpload span:first-child {
  text-align: right;
}

.innerUpload span {
  min-width: 56px;
  display: inline-block;
  margin-right: 20px;
  line-height: 40px;
}
</style>
